var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditDoc = function SvgEditDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.945 1.055A3.578 3.578 0 0014.4 0c-.962 0-1.867.375-2.547 1.055L1.787 11.12a.703.703 0 00-.18.309l-1.581 5.68a.703.703 0 00.87.864l5.68-1.613a.703.703 0 00.305-1.173l-3.58-3.591 8.342-8.344 3.103 3.103-6.387 6.37a.703.703 0 00.993.995l7.593-7.572A3.578 3.578 0 0018 3.601c0-.962-.374-1.866-1.055-2.546zM5.041 15.334l-3.324.944.93-3.345 2.394 2.4zm10.91-10.181l-.209.21-3.104-3.105.209-.209a2.18 2.18 0 011.552-.643 2.18 2.18 0 011.552.643c.415.415.643.966.643 1.552a2.18 2.18 0 01-.642 1.552z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editDoc.09043042.svg";
export { ForwardRef as ReactComponent };